import InitialSignUpScreen from './InitialSignUpScreen';

export default InitialSignUpScreen;
